import type { FavoriteRecordRef } from "@remi/types/favorite";

export const getRecordFavoriteKey = (ref: FavoriteRecordRef): string => `record:${ref.type}:${ref.id}`;
export const getPageFavoriteKey = (navKey: string): string => `page:${navKey}`;
export const getCustomViewFavoriteKey = (viewId: string): string => `custom:${viewId}`;

// The "favorite:" prefix is not a sidebar row kind, so the resolver and customize drawer skip these rows.
export const getFavoritePlacementRowId = (key: string): string => `favorite:${key}`;
